import { LitElement, html, css } from 'lit';
import './DashboardAppMenuGroup.js';

class DashboardAppList extends LitElement {
  static styles = css`
    :host { display: block; }

    .app-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 20px;
      width: 100%;
    }

    .app-card {
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      cursor: pointer;
    }

    .app-card:hover {
      border-color: #3b82f6;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      transform: translateY(-4px);
    }

    .app-header {
      padding: 24px 24px 20px 24px;
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .app-avatar {
      width: 52px;
      height: 52px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: bold;
      color: white;
      text-transform: uppercase;
      flex-shrink: 0;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    }

    .color-1 { background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%); }
    .color-2 { background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%); }
    .color-3 { background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%); }
    .color-4 { background: linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%); }
    .color-5 { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }

    .app-title-group {
      display: flex;
      flex-direction: column;
      gap: 6px;
      overflow: hidden;
      flex-grow: 1;
    }

    .app-name {
      margin: 0;
      font-size: 1.125rem;
      font-weight: 800;
      color: #111827;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: -0.025em;
    }

    .app-key {
      font-family: ui-monospace, SFMono-Regular, Consolas, monospace;
      font-size: 12px;
      color: #6b7280;
      background: #f3f4f6;
      padding: 4px 8px;
      border-radius: 6px;
      display: inline-flex;
      align-items: center;
      width: fit-content;
      border: 1px solid #e5e7eb;
    }

    .app-actions-bar {
      border-top: 1px solid #f3f4f6;
      background-color: #f9fafb;
      padding: 16px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      margin-top: auto;
      flex-wrap: wrap;
    }

    .enter-link {
      font-size: 14px;
      font-weight: 600;
      color: #3b82f6;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .action-group { 
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }

    button {
      display: inline-flex; align-items: center; justify-content: center; gap: 8px;
      padding: 10px 16px; font-size: 13px; font-weight: 600; border: 1px solid transparent;
      border-radius: 8px; cursor: pointer; transition: all 0.2s ease; white-space: nowrap;
    }

    .btn-icon { padding: 8px 12px; background-color: white; color: #6b7280; border: 1px solid #d1d5db; border-radius: 8px; }
    .btn-icon:hover:not(:disabled) { background-color: #f3f4f6; color: #111827; }
    
    .btn-danger-outline { background-color: white; color: #ef4444; border: 1px solid #fca5a5; }
    .btn-danger-outline:hover:not(:disabled) { background-color: #fef2f2; border-color: #ef4444; }

    button:disabled { opacity: 0.5; cursor: not-allowed; box-shadow: none; }

    .empty-state {
      padding: 60px 20px;
      text-align: center;
      color: #6b7280;
      background: #f9fafb;
      border: 2px dashed #d1d5db;
      border-radius: 16px;
      font-size: 15px;
      grid-column: 1 / -1;
    }

    /* オンボーディング用スタイル */
    .welcome-onboarding {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
      background: #ffffff;
      border: 2px dashed #bfdbfe;
      border-radius: 16px;
      text-align: center;
      grid-column: 1 / -1;
      box-shadow: 0 4px 15px rgba(0,0,0,0.03);
    }
    .onboarding-icon {
      font-size: 48px;
      margin-bottom: 16px;
      background: #eff6ff;
      width: 96px;
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: #3b82f6;
    }
    .onboarding-title {
      font-size: 1.5rem;
      font-weight: 800;
      color: #1f2937;
      margin: 0 0 10px 0;
    }
    .onboarding-desc {
      color: #6b7280;
      margin: 0 0 30px 0;
      line-height: 1.6;
    }
    .step-indicator {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 35px;
      flex-wrap: wrap;
      justify-content: center;
    }
    .step {
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: bold;
      background: #f3f4f6;
      color: #9ca3af;
    }
    .step.active {
      background: #3b82f6;
      color: #ffffff;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4);
    }
    .step.done {
      background: #d1fae5;
      color: #059669;
    }
    .step-arrow { color: #d1d5db; font-size: 14px; }
    .btn-start-large {
      background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%);
      color: white;
      border: none;
      padding: 14px 28px;
      border-radius: 12px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      transition: transform 0.2s, box-shadow 0.2s;
    }
    .btn-start-large:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 15px rgba(79, 70, 229, 0.3);
    }

    @media (max-width: 768px) {
      .app-grid { grid-template-columns: 1fr; }
    }
  `;

  static properties = {
    apps: { type: Array },
    versions: { type: Array },
    mode: { type: String }, // 'workbench', 'archive'
    identKey: { type: String },
  };

  firstUpdated() {
    const fontAwasomeStyle = document.querySelector("link[rel='stylesheet'][data-name='fontawesomev6']");
    if (fontAwasomeStyle) {
      const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
      fontAwasomeStyleClone.removeAttribute('disabled');
      this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);
    }
  }

  _dispatch(action, appKey, e) {
    if (e) e.stopPropagation();
    this.dispatchEvent(new CustomEvent('app-action', {
      detail: { action, appKey },
      bubbles: true,
      composed: true
    }));
  }

  _getAvatarProps(appName) {
    const char = appName ? appName.charAt(0).toUpperCase() : 'A';
    const colorIndex = (appName ? appName.charCodeAt(0) % 5 : 0) + 1;
    return { char, colorClass: `color-${colorIndex}` };
  }

  render() {
    if (!this.apps || this.apps.length === 0) {
      return html`
        <div class="welcome-onboarding">
          <div class="onboarding-icon"><i class="fa-solid fa-rocket"></i></div>
          <h2 class="onboarding-title">Pwappyへようこそ！</h2>
          <p class="onboarding-desc">
            アプリ開発を始めるための最初のステップです。<br>
            まずはアプリケーションの「器」を作成しましょう。
          </p>
          
          <div class="step-indicator">
            <div class="step active">1. アプリの作成</div>
            <div class="step-arrow"><i class="fa-solid fa-chevron-right"></i></div>
            <div class="step">2. エディタ起動</div>
          </div>

          <button class="btn-start-large" @click=${() => this.dispatchEvent(new CustomEvent('trigger-create-app', { bubbles: true, composed: true }))}>
            <i class="fa-solid fa-plus"></i> 最初のアプリを作成する
          </button>
        </div>
      `;
    }

    return html`
      <div class="app-grid">
        ${this.apps.map(app => {
      const avatar = this._getAvatarProps(app.appName);

      const hasPublishedVersion = (this.versions || []).some(v =>
        v.appKey === app.appKey && v.status === 'published'
      );

      return html`
              <div class="app-card" @click=${() => this.mode === 'workbench' ? this._dispatch('select', app.appKey) : null}>
                <div class="app-header">
                  <div class="app-avatar ${avatar.colorClass}">${avatar.char}</div>
                  <div class="app-title-group">
                    <h3 class="app-name" title="${app.appName}">${app.appName}</h3>
                    <span class="app-key" title="アプリキー: ${app.appKey}"><i class="fa-solid fa-key" style="margin-right: 4px; opacity:0.5;"></i>${app.appKey}</span>
                  </div>
                </div>

                <div class="app-actions-bar">
                  ${this.mode === 'workbench' ? html`
                    <div class="enter-link">詳細を開く <i class="fa-solid fa-arrow-right"></i></div>
                    <div class="action-group">
                      <button class="btn-icon" @click=${(e) => this._dispatch('archive', app.appKey, e)} title="アーカイブに移動">
                        <i class="fa-solid fa-box-archive"></i>
                      </button>
                    </div>
                  ` : html`

                  ${hasPublishedVersion ? html`
                      <div @click=${(e) => e.stopPropagation()} style="margin-right: auto;">
                        <dashboard-app-menu-group 
                            .identKey=${this.identKey} 
                            .appKey=${app.appKey}>
                        </dashboard-app-menu-group>
                      </div>
                    ` : ''}

                    <div class="action-group" style="flex-grow: 1; justify-content: flex-end;">
                      <button style="flex-grow:1; background:#10b981; color:white;" @click=${(e) => this._dispatch('restore', app.appKey, e)}>
                        <i class="fa-solid fa-rotate-left"></i> 復元
                      </button>
                      <button class="btn-danger-outline" @click=${(e) => this._dispatch('delete', app.appKey, e)}>
                        <i class="fa-solid fa-trash"></i> 完全削除
                      </button>
                    </div>
                  `}
                </div>
              </div>
            `;
    })}
      </div>
    `;
  }
}
customElements.define('dashboard-app-list', DashboardAppList);